/**
 * 📋 SDLC 6.3.1 UNIFIED SPECIFICATION STANDARD FILE HEADER
 * ===============================================================================
 * FILE: frontend/src/lib/utils.ts
 * PURPOSE: Utility functions and helper methods
 * SDLC FRAMEWORK VERSION: 6.1.1 (7-Pillar + 3-Section + Long-Running Agent Protocol)
 * PILLAR: P1 (Stage 06 - BUILD) + P2 (Sprint Governance)
 * SPRINT GOVERNANCE: Rule 2: Milestone-Gated Roadmaps
 *
 * CTO MANDATE: Production-ready React component with enterprise quality standards
 *
 * @business-context
 * - Domain: Utility Functions, Helper Libraries, Vietnamese F&B Utilities
 * - Impact: Code Reusability, Developer Productivity, Maintainability
 * - Stakeholders: Development Team, Frontend Engineers
 *
 * @technical-architecture
 * - Layer: Utility Layer, Helper Functions
 * - Pattern: Pure Functions, Utility Patterns, Type-Safe Helpers
 * - Dependencies: TypeScript, Lodash (optional)
 */

import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

// cn__merges_classes__returns_string
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
